// contract-channel
import { axios } from '../index'

let scope = 'house'

export { axios as house }

export default {
  houseSpace: {
    list(id) {
      return axios.post('list/houseSpace/back', {
        houseSpaceManagerId: id,
        transformType: 'ALL',
      })
    },
    retrieve(id) {
      return axios.post('house/get', { houseSpaceId: id })
    },
  },
  // 基本接口
  house: {
    // 获取有密码的房间 @param {houseId : String}
    getSendPwdRooms: params =>
      axios.post(`/${scope}/list/getSendPwdRooms/detailInfo`, params),
    getHouseOptions: id => axios.get(`/${scope}/equip/${id}`),
    getHouseList: params => axios.post(`${scope}/list/houseSpace`, params),
    // 查询 租客已租房源列表
    getMaintainHouseList: params =>
      axios.post(`/${scope}/list/houseSpace/maintain`, params),
    // export async function
    getIntervalPerfeeAmount: params =>
      axios.get(`/${scope}/getIntervalPerfeeAmount`, { params: params }),
    PerfeeAmountList: params =>
      axios.post(`/${scope}/getPerfeeAmountList`, { houseSpaceIds: params }),
    PerfeeAmount: params =>
      axios.get(`/${scope}/getPerfeeAmount`, { params }),

  },
  companyMessage: {
    // 根据房源片区id 获取对应公司的名字
    getCompanyName(company) {
      return axios.post(`${scope}/company/get/houseCompanyMapping`, company)
    },
    // 查询所有公司信息
    getCompanyAll() {
      return axios.get(`${scope}/company/list/all`)
    },
    // 报表页面 查询所有公司信息
    getCompanyAllInform() {
      return axios.get(`${scope}/company/listAllForH5`)
    }
  },
  // 根据zoneId 获取 小区列表,以及 根据 小区Id 获取 楼栋
  getBlockListByZoneId: params =>
    axios.post(`${scope}/list/block/building`, params),
  // 企业租客 预定已经预定的房间和空置房间
  setReserved: params =>
    axios.post(`${scope}/landlord/reserved/rentable`, params),
  // 房源 操作记录的添加和查询
  operation: {
    // 查询操作记录
    getOperationList: params =>
      axios.post(`${scope}/operation/list/houseSpaceOperation`, params),
    // 添加操作记录
    addOperationInform: params =>
      axios.post(`${scope}/operation/add/houseSpaceOperation`, params),
  },
  // 搜索接口，搜索可以下架的房源
  getHouseSpace: params => axios.post(`${scope}/listSimpleHouseSpace`, params),

  // 获取其他状态的房源列表
  getHouseListOfOtherStatus: params =>
    axios.post(`${scope}/count/OtherStatus/v2`, params),

  // 房源价格配置页面查询
  getHouseHousePrice: params =>
    axios.post(`${scope}/pageHousePrice`, params),
  // 导出房源价格模版 ssf
  housePriceTemplate: params =>
    axios.post(`${scope}/download/housePriceTemplate`, params, {
      responseType: 'blob'
    }),
  // 导入房源价格
  readExcelHousePrice(params) {
    return axios.post(`${scope}/import/readExcelHousePrice`, params)
  },
  // 预览导入的excel
  previewPriceUpdate(params) {
    return axios.post(`${scope}/import/previewPriceUpdate`, params)
  },
  // 提交导入请求
  submitPriceUpdate(params) {
    return axios.post(`${scope}/import/submitPriceUpdate`, params)
  },
  // 修改房源用途
  modifyHouseSpacePurpose: params =>
    axios.post(`${scope}/updateHouseSpacePurpose`, params),
  // 修改房源标签
  updateHouseLabel: params =>
    axios.post(`${scope}/updateHouseLabel`, params),
}



// WEBPACK FOOTER //
// ./src/xhr/services/house.js